<template>
  <div pageA>
    <article>
      <div class="cover">
        <div class="cont">
          <h1></h1>
          <a class="btn-play" @click="setMovOn"></a>
          <div class="join" v-if="env === 'pc'">
            <p>
              <a @click="setDownload"></a>
            </p>
          </div>
          <p class="circle" v-if="env === 'pc'"></p>
          <div class="download" v-if="env === 'mob'">
            <a @click="goMarket('osx')"></a>
            <a @click="goMarket('google')"></a>
          </div>
        </div>
        <ul class="m-quick" :class="{on:qOn}">
          <a v-if="env==='mob'" class="btn-toggle" @click="qOn = !qOn"></a>
          <li v-for="(item,id) in media" :key="id" :style="{backgroundImage:`url('${getImage(item.thumb)}')`}">
            <a @click="goMedia(item.id)"></a>
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'pageA',
  data() {
    return {
      qOn: false,
      imgUrl: '/static/img/',
      media: [
        { thumb: 't1.png', id: '0' },
        { thumb: 't2.png', id: '1' },
        { thumb: 't3.png', id: '2' },
        { thumb: 't4.png', id: '3' },
      ],
    };
  },
  computed: {
    env() {
      return this.$store.state.environment;
    },
  },
  methods: {
    setDownload() {
      window.gtag('event', 'click', { event_category: 'Main_Download' });
      this.$store.commit('onDownload');
    },
    goMarket(os) {
      if (os === 'osx') {
        window.open('https://app.adjust.com/ybtdix8?redirect=https%3A%2F%2Fapps.apple.com%2Fkr%2Fapp%2Fid1258046552');
        window.gtag('event', 'click', { event_category: 'MoAmarket' });
      } else {
        window.open('https://app.adjust.com/ybtdix8?redirect=https://play.google.com/store/apps/details?id=com.gamevil.talion.android.google.global.normal');
        window.gtag('event', 'click', { event_category: 'MoGmarket' });
      }
    },
    goMedia(id) {
      if (this.env === 'pc') {
        this.$router.push(`media?code=${id}&reset=Y`);
      } else {
        this.$emit('goPage', `media?code=${id}&reset=Y`);
      }
    },

    setMovOn() {
      window.gtag('event', 'click', { event_category: 'Main_View' });
      this.$store.commit('onMov', 'https://www.youtube.com/embed/Cz8tCAc8B8w');
    },
    getImage(item) {
      return `${this.imgUrl}pc/p1/${item}`;
    },
  },
  mounted() {
  },
};
</script>

<style lang="less">
  @import '../less/proj';
  .mob{
    [pageA]{ .cover("@{mob}/p1/bg.jpg"); .bg-x(50%); .w(720); overflow: hidden;
      article{
        .cover{ .pt(520); .pb(170);
          .cont{.rel;
            >*{.mh-c;}
            h1{.contain("@{mob}/p1/title.png"); .wh(685px,335); }
            .subtitle{.contain("@{mob}/p1/subtitle1.png"); .wh(600,92); .mt(-40); .mb(20);}
            .btn-play{.block; .contain("@{mob}/btn-play.png"); .wh(120); .mb(0px);}
            .join{ .wh(622,205);
              p{ .wh(100%);
                a{.ib; .contain("@{mob}/p1/btn-join.png"); .wh(100%);}
              }
            }
            .period{.contain("@{mob}/p1/period.png"); .wh(660,120); .pb(170);}
          }
          .download{.wh(586,296); .contain("@{mob}/p1/download.png"); .rel; .p(95,10,0); .-box;
            a{.ib; .wh(49%,86);
              &:last-of-type{.fr;}
            }
          }

          .m-quick{ .abs; z-index:10;  .r(50%); .r(20); .t(100); .wh(188,170); overflow: hidden; background:rgba(0,0,0,0.7); .p(14,6,7); transition: .5s; .-a(rgba(214,176,139,.5));
            &.on{.h(650);}
            &:before{.cnt; .contain("@{mob}/p1/mtitle.png"); .wh(100%,21); .bg-sx(57); .bg-c; }
            .btn-toggle{ .abs; z-index: 10; .wh(40,40); .r(4); .t(4);
              &:before{ .cnt; .abs; .r(10); .t(50%); .wh(18,2); transition: .5s; background:#d6b08b; transform: translate(-2%,-50%);}
              &:after{ .cnt; .abs; .r(18); .t(50%); .wh(2,18); transition: .5s; background:#d6b08b; transform: translateY(-50%);}
            }
            li{.contain; .wh(188,140); .block; .m(14,0); .no-repeat;
              a{.block; .wh(100%);}
            }

            &.on{
              .btn-toggle{
                &:before{transform: translate(-2%,-50%) rotate(180deg);}
                &:after{transform: translateY(-50%) rotate(90deg);}
              }
            }
          }
        }
      }
    }
  }
  .pc{
    [pageA]{ .fix; .cover("@{pc}/p1/bg.jpg"); .bg-x(50%); .wh(100%); .-box; .min-h(100%); .-box; .min-w(1140px);
      article{ .w(100%); .abs; .t(85px); .b(78px);
        .cover{.wh(100%); .rel; overflow-y:auto; overflow-x:hidden; -webkit-overflow-scrolling: touch;
          .cont{.wh(100%,800px); .abs; transform: translateY(-50%); .t(60%); transition: .5s;
            >*{.mh-c;}
            h1{.contain("@{pc}/p1/title.png"); .wh(794px,351px);  .bg-x(-10px);}
            .period{.contain("@{pc}/p1/period.png"); .wh(520px,92px);}
            .join{.wh(488px,100px); .rel; .mb(40px);
              &:after{.cnt; .abs; .contain("@{pc}/p1/circle.png"); .wh(263px); .l(-190px); .t(-148px);}
              p{ .wh(100%); overflow: hidden; .rel;
                a{.block; .contain("@{pc}/p1/btn-join.png"); .wh(100%); .bg-y(50%);
                  &:before{.cnt; .contain("@{pc}/p1/btn-join-et.png"); .wh(466px,61px); .abs; .t(-10px); .l(-400px); opacity: 0;  transition: .5s;}
                  &:after{.cnt; .contain("@{pc}/p1/btn-join-eb.png"); .wh(466px,61px); .abs; .b(-24px); .r(-400px); opacity: 0; transition: .5s;}
                  &:hover{
                    &:before{opacity: 1; .l(20px);}
                    &:after{opacity: 1; .r(20px);}
                  }

                }
              }
            }
            .btn-play{.block; .contain("@{pc}/btn-play.png"); .wh(77px); .mb(20px);}
          }
          .m-quick{ .abs; z-index:10;  .r(50%); .mr(-700px); .t(50%); .mt(-350px); background:rgba(0,0,0,0.8); .-a(rgba(255,210,166,.5)); .p(0px,6px,7px); box-shadow: 8px 10px 10px 7px rgba(0,0,0,0.6);
            &:before{.cnt; .contain("@{pc}/p1/mtitle.png"); .wh(200px,44px); }
            li{.contain; .wh(100%,135px); .block; .p(6px,0px); .no-repeat;
              a{.block; .wh(100%);}
            }
          }
        }
      }
      @media screen and (max-width: @screen-xxl-min){
        article{.t(63px); .b(56px);
          .cover{
            .m-quick{.mr(-600px);}
          }
        }
      }
      @media screen and (max-height: 1100px){
        article{
          .cover{
            .cont{transform:translateY(0) scale(0.85); .t(150px); }
            .m-quick{ .t(50); transform: translateY(0); .mt(0);  }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pageA.vue